module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-27.c12c40d8.jpg";